/* import __COLOCATED_TEMPLATE__ from './contacts-list-section.hbs'; */
import { action } from '@ember/object';
import { scrollToValidationError } from 'client-portal/utils/validate-record';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { waitForRender } from 'ember-simplepractice/utils/waiters';
import Component from '@glimmer/component';
import styles from './contacts-list-section.module.scss';

export default class SiteDocumentsContactInfoContactsListSection extends Component {
  styles = styles;

  @service session;
  @service store;

  @tracked isAddModalOpen = false;
  @tracked isRemoveModalOpen = false;
  @tracked contactPendingRemoval = null;
  @tracked newContact = null;

  willDestroy() {
    super.willDestroy(...arguments);

    if (this.newContact) {
      this.contacts.removeObject(this.newContact);
    }
  }

  get contacts() {
    return this.args.demographicsForm.contacts;
  }

  @action
  openAddModal() {
    this.newContact = this.store.createFragment('contact-info/contact');
    this.newContact.set('isDraft', true);
    this.contacts.addObject(this.newContact);
    this.isAddModalOpen = true;
  }

  @action
  closeAddModal() {
    if (this.newContact) {
      this.contacts.removeObject(this.newContact);
    }

    this.newContact = null;
    this.isAddModalOpen = false;
  }

  @action
  async handleAddContact() {
    if (this.newContact.validations.isInvalid) {
      this.newContact.set('isDirty', true);
      await waitForRender();
      scrollToValidationError('.add-contact-modal-form');
      return;
    }

    this.newContact.set('isDraft', false);

    this.newContact = null;
    this.isAddModalOpen = false;
  }

  @action
  openRemoveModal(contact) {
    this.contactPendingRemoval = contact;
    this.isRemoveModalOpen = true;
  }

  @action
  closeRemoveModal() {
    this.isRemoveModalOpen = false;
    this.contactPendingRemoval = null;
  }

  @action
  handleRemove() {
    if (!this.contactPendingRemoval) return;

    if (this.contactPendingRemoval.isNewContact) {
      this.contacts.removeObject(this.contactPendingRemoval);
    } else {
      this.contactPendingRemoval.set('isMarkedForDeletion', true);
    }
    this.closeRemoveModal();
  }

  get showEmergencyContactRequiredInfo() {
    return (
      !this.args.isReview && this.args.demographicsForm.shouldValidateContactsListEmergencyContact
    );
  }
}
